import { moveToFulfilled, moveToPending, remove } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import { getGraphqlApiErrorReason } from '../..';
import type { GroupLeaveAction } from '../../domains/groupJoinLeave/actions.types';

import type { LeaveGroupRequests } from './types';

export type LeaveGroupRequestsAction = GroupLeaveAction;

const initialState: LeaveGroupRequests = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<LeaveGroupRequests, LeaveGroupRequestsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP.LEFT_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP.LEFT_FULFILLED': {
      return moveToFulfilled(state, {
        [action.payload.groupId]: {
          id: action.payload.groupId,
          error: false,
        },
      });
    }
    case 'GROUP.LEFT_REJECTED': {
      return moveToFulfilled(state, {
        [action.payload.groupId]: {
          id: action.payload.groupId,
          error: true,
          reason: getGraphqlApiErrorReason(action.payload.error),
        },
      });
    }
    case 'GROUP.FINAL_ADMIN_WARNING_DISMISSED':
      return remove(state, [action.payload.groupId]);
    default:
      return state;
  }
};

export default reducer;
